<script>
import { authComputed } from '@state/helpers'

export default {
  name: 'OrganizationSocialForm',
  props: {
    submitError: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      hasX: false,
      hasFacebook: false,
      hasInstagram: false,
      hasLinkedIn: false,
      hasCustom: false,
      xLink: '',
      facebookLink: '',
      instagramLink: '',
      linkedinLink: '',
      email: '',
      phone: '',
      pickedLogo: '',
      marketingRelease: 0,
      customSocials: [],
      uploadFile: '',
      uploadFileName: '',
      errors: {
        xLink: '',
        facebookLink: '',
        instagramLink: '',
        linkedinLink: '',
        email: '',
        phone: '',
        marketingRelease: '',
        uploadFile: '',
      },
      customSocialErrors: [],
    }
  },
  computed: { ...authComputed },
  watch: {
    hasCustom(newValue) {
      if (newValue && this.customSocials.length === 0) {
        this.addSocialLink()
      }
    },
  },
  mounted() {},
  methods: {
    submitSocialsForm() {
      if (this.hasX && !this.xLink) {
        this.errors.xLink = 'X social link required.'
      }
      if (this.hasFacebook && !this.facebookLink) {
        this.errors.facebookLink = 'Facebook social link required.'
      }
      if (this.hasInstagram && !this.instagramLink) {
        this.errors.instagramLink = 'Instagram social link required.'
      }
      if (this.hasLinkedIn && !this.linkedinLink) {
        this.errors.linkedinLink = 'LinkedIn social link required.'
      }
      if (!this.email) {
        this.errors.email = 'Email required.'
      } else if (!this.validEmail(this.email)) {
        this.errors.email = 'Valid email required.'
      }
      if (!this.phone) {
        this.errors.phone = 'Phone number required.'
      }
      if (!this.uploadFile) {
        this.errors.uploadFile = 'Logo required'
      }
      this.validateCustomSocialLinks()
      if (
        !Object.values(this.errors).some((x) => x !== '') &&
        !Object.values(this.customSocialErrors).some(
          (x) => x.title !== '' || x.link !== ''
        )
      ) {
        this.$emit('clear-submit-errors')
        this.$emit('post-submit-social', {
          hasX: this.hasX,
          xLink: this.xLink,
          hasFacebook: this.hasFacebook,
          facebookLink: this.facebookLink,
          hasInstagram: this.hasInstagram,
          instagramLink: this.instagramLink,
          hasLinkedIn: this.hasLinkedIn,
          linkedinLink: this.linkedinLink,
          hasCustom: this.hasCustom,
          customSocials: this.customSocials,
          email: this.email,
          phone: this.phone,
          uploadFile: this.uploadFile,
          uploadFileName: this.uploadFileName,
        })
      }
    },
    validateCustomSocialLinks() {
      this.customSocials.forEach((social, index) => {
        if (!social.title) {
          this.customSocialErrors[index].title = 'Social tittle required'
        }
        if (!social.link) {
          this.customSocialErrors[index].link = 'Social link required'
        }
      })
    },
    clearSubmitErrors(fieldName) {
      if (fieldName) {
        this.errors[fieldName] = ''
      }
      this.$emit('clear-sign-up-errors')
    },
    clearCustomSocialErrors(linkIndex, isTitle) {
      if (isTitle) {
        this.customSocialErrors[linkIndex].title = ''
        return
      }

      this.customSocialErrors[linkIndex].link = ''
    },
    validEmail: function (email) {
      const rule =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return rule.test(email)
    },
    uploadUserFile() {
      const file = this.$refs.file.files[0]
      this.uploadFileName = file.name
      this.uploadFile = file
    },
    onUploadClick() {
      this.$refs.file.click()
    },
    addSocialLink() {
      this.customSocials.push({ title: '', link: '' })
      this.customSocialErrors.push({ title: '', link: '' })
    },
    removeSocialLink(linkIndex) {
      this.customSocials.splice(linkIndex, 1)
      this.customSocialErrors.splice(linkIndex, 1)
    },
  },
}
</script>

<template>
  <div>
    <div class="flex items-center mt-8 -mx-2">
      <div class="flex items-center gap-3">
        <div
          class="rounded-full text-center bg-blue text-white flex items-center justify-center"
          style="height: 35px; width: 35px"
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            height="20px"
            viewBox="0 -960 960 960"
            width="20px"
            fill="white"
          >
            <path
              d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"
            /></svg
        ></div>
        <span class="text-blue">Info</span>
      </div>
      <div class="h-2px w-2/5 bg-gray ml-4 mr-4"></div>
      <div class="flex items-center gap-3">
        <p
          class="rounded-full text-center bg-blue text-white"
          style="line-height: 35px; width: 35px"
          >2</p
        >
        <span class="text-blue">Social</span>
      </div>
      <div class="h-2px w-2/5 bg-gray ml-4 mr-4"></div>
      <div class="flex items-center gap-3">
        <p
          class="rounded-full text-center bg-transparent border-gray border-solid border-2 text-gray"
          style="line-height: 35px; width: 40px"
          >3</p
        >
        <span class="text-gray">Admins</span>
      </div>
    </div>
    <div class="text-left">
      <fieldset class="mt-8 flex -mx-2">
        <legend class="mb-px text-gray">Social Links:</legend>
        <div class="flex flex-col items-start w-full gap-4">
          <div class="flex items-left h-10 w-full">
            <div class="flex items-center w-2/12">
              <input
                id="has-x"
                v-model="hasX"
                type="checkbox"
                class="checkbox mr-2"
                :value="true"
              />
              <label
                class="inline-flex items-center cursor-pointer"
                for="has-x"
              >
                X</label
              >
            </div>
            <div v-show="hasX" class="relative w-10/12">
              <input
                v-model="xLink"
                type="text"
                name="x-link"
                placeholder="X Link"
                class="input"
                :class="[errors.xLink !== '' ? 'border-red' : '']"
                @input="clearSubmitErrors('xLink')"
              />
              <svg
                v-if="errors.xLink !== ''"
                class="absolute right-0 top-0 mr-7 mt-2.5"
                xmlns="http://www.w3.org/2000/svg"
                width="17.433"
                height="15.57"
                viewBox="0 0 17.433 15.57"
              >
                <path
                  class="a"
                  fill="red"
                  d="M19.066,17.847,12.211,5.978h0a1.808,1.808,0,0,0-.342-.483,1.772,1.772,0,0,0-2.505,0,1.715,1.715,0,0,0-.307.414h0L2.2,17.781v0a1.727,1.727,0,0,0-.246.535,1.769,1.769,0,0,0,1.764,2.229l13.707,0h0a1.77,1.77,0,0,0,1.636-2.7Zm-7.64.057a1.2,1.2,0,0,1-1.661,0,1.072,1.072,0,0,1-.354-.8,1.087,1.087,0,0,1,.354-.807,1.182,1.182,0,0,1,1.661,0,1.086,1.086,0,0,1,.354.807A1.07,1.07,0,0,1,11.426,17.9Zm.283-6.941c-.059.278-.136.6-.226.977-.086.352-.187.792-.3,1.32s-.229,1.178-.354,1.953h-.475q-.185-1.175-.355-1.958t-.3-1.311c-.079-.323-.15-.639-.216-.951a3.652,3.652,0,0,1-.1-.7,1.076,1.076,0,0,1,.351-.808,1.237,1.237,0,0,1,1.693,0,1.067,1.067,0,0,1,.362.808A3.393,3.393,0,0,1,11.709,10.963Z"
                  transform="translate(-1.898 -4.978)"
                />
              </svg>
              <span
                v-if="errors.xLink !== ''"
                class="right-0 absolute mr-5 text-red text-xxs capitalize text-right block w-full"
                >{{ errors.xLink }}
              </span>
            </div>
          </div>
          <div class="flex items-left h-10 w-full">
            <div class="flex items-center w-2/12">
              <input
                id="has-facebook"
                v-model="hasFacebook"
                type="checkbox"
                class="checkbox mr-2"
                :value="true"
              />
              <label
                class="inline-flex items-center cursor-pointer"
                for="has-facebook"
              >
                Facebook</label
              >
            </div>
            <div v-show="hasFacebook" class="relative w-10/12">
              <input
                v-model="facebookLink"
                type="text"
                name="facebook-link"
                placeholder="Facebook Link"
                class="input"
                :class="[errors.facebookLink !== '' ? 'border-red' : '']"
                @input="clearSubmitErrors('facebookLink')"
              />
              <svg
                v-if="errors.facebookLink !== ''"
                class="absolute right-0 top-0 mr-7 mt-2.5"
                xmlns="http://www.w3.org/2000/svg"
                width="17.433"
                height="15.57"
                viewBox="0 0 17.433 15.57"
              >
                <path
                  class="a"
                  fill="red"
                  d="M19.066,17.847,12.211,5.978h0a1.808,1.808,0,0,0-.342-.483,1.772,1.772,0,0,0-2.505,0,1.715,1.715,0,0,0-.307.414h0L2.2,17.781v0a1.727,1.727,0,0,0-.246.535,1.769,1.769,0,0,0,1.764,2.229l13.707,0h0a1.77,1.77,0,0,0,1.636-2.7Zm-7.64.057a1.2,1.2,0,0,1-1.661,0,1.072,1.072,0,0,1-.354-.8,1.087,1.087,0,0,1,.354-.807,1.182,1.182,0,0,1,1.661,0,1.086,1.086,0,0,1,.354.807A1.07,1.07,0,0,1,11.426,17.9Zm.283-6.941c-.059.278-.136.6-.226.977-.086.352-.187.792-.3,1.32s-.229,1.178-.354,1.953h-.475q-.185-1.175-.355-1.958t-.3-1.311c-.079-.323-.15-.639-.216-.951a3.652,3.652,0,0,1-.1-.7,1.076,1.076,0,0,1,.351-.808,1.237,1.237,0,0,1,1.693,0,1.067,1.067,0,0,1,.362.808A3.393,3.393,0,0,1,11.709,10.963Z"
                  transform="translate(-1.898 -4.978)"
                />
              </svg>
              <span
                v-if="errors.facebookLink !== ''"
                class="right-0 absolute mr-5 text-red text-xxs capitalize text-right block w-full"
                >{{ errors.facebookLink }}
              </span>
            </div>
          </div>
          <div class="flex items-left h-10 w-full">
            <div class="flex items-center w-2/12">
              <input
                id="has-instagram"
                v-model="hasInstagram"
                type="checkbox"
                class="checkbox mr-2"
                :value="true"
              />
              <label
                class="inline-flex items-center cursor-pointer"
                for="has-instagram"
              >
                Instagram</label
              >
            </div>
            <div v-show="hasInstagram" class="relative w-10/12">
              <input
                v-model="instagramLink"
                type="text"
                name="instagram-link"
                placeholder="Instagram Link"
                class="input"
                :class="[errors.instagramLink !== '' ? 'border-red' : '']"
                @input="clearSubmitErrors('instagramLink')"
              />
              <svg
                v-if="errors.instagramLink !== ''"
                class="absolute right-0 top-0 mr-7 mt-2.5"
                xmlns="http://www.w3.org/2000/svg"
                width="17.433"
                height="15.57"
                viewBox="0 0 17.433 15.57"
              >
                <path
                  class="a"
                  fill="red"
                  d="M19.066,17.847,12.211,5.978h0a1.808,1.808,0,0,0-.342-.483,1.772,1.772,0,0,0-2.505,0,1.715,1.715,0,0,0-.307.414h0L2.2,17.781v0a1.727,1.727,0,0,0-.246.535,1.769,1.769,0,0,0,1.764,2.229l13.707,0h0a1.77,1.77,0,0,0,1.636-2.7Zm-7.64.057a1.2,1.2,0,0,1-1.661,0,1.072,1.072,0,0,1-.354-.8,1.087,1.087,0,0,1,.354-.807,1.182,1.182,0,0,1,1.661,0,1.086,1.086,0,0,1,.354.807A1.07,1.07,0,0,1,11.426,17.9Zm.283-6.941c-.059.278-.136.6-.226.977-.086.352-.187.792-.3,1.32s-.229,1.178-.354,1.953h-.475q-.185-1.175-.355-1.958t-.3-1.311c-.079-.323-.15-.639-.216-.951a3.652,3.652,0,0,1-.1-.7,1.076,1.076,0,0,1,.351-.808,1.237,1.237,0,0,1,1.693,0,1.067,1.067,0,0,1,.362.808A3.393,3.393,0,0,1,11.709,10.963Z"
                  transform="translate(-1.898 -4.978)"
                />
              </svg>
              <span
                v-if="errors.instagramLink !== ''"
                class="right-0 absolute mr-5 text-red text-xxs capitalize text-right block w-full"
                >{{ errors.instagramLink }}
              </span>
            </div>
          </div>
          <div class="flex items-left h-10 w-full">
            <div class="flex items-center w-2/12">
              <input
                id="has-linkedin"
                v-model="hasLinkedIn"
                type="checkbox"
                class="checkbox mr-2"
                :value="true"
              />
              <label
                class="inline-flex items-center cursor-pointer"
                for="has-linkedin"
              >
                LinkedIn</label
              >
            </div>
            <div v-show="hasLinkedIn" class="relative w-10/12">
              <input
                v-model="linkedinLink"
                type="text"
                name="linkedin-link"
                placeholder="LinkedIn Link"
                class="input"
                :class="[errors.linkedinLink !== '' ? 'border-red' : '']"
                @input="clearSubmitErrors('linkedinLink')"
              />
              <svg
                v-if="errors.linkedinLink !== ''"
                class="absolute right-0 top-0 mr-7 mt-2.5"
                xmlns="http://www.w3.org/2000/svg"
                width="17.433"
                height="15.57"
                viewBox="0 0 17.433 15.57"
              >
                <path
                  class="a"
                  fill="red"
                  d="M19.066,17.847,12.211,5.978h0a1.808,1.808,0,0,0-.342-.483,1.772,1.772,0,0,0-2.505,0,1.715,1.715,0,0,0-.307.414h0L2.2,17.781v0a1.727,1.727,0,0,0-.246.535,1.769,1.769,0,0,0,1.764,2.229l13.707,0h0a1.77,1.77,0,0,0,1.636-2.7Zm-7.64.057a1.2,1.2,0,0,1-1.661,0,1.072,1.072,0,0,1-.354-.8,1.087,1.087,0,0,1,.354-.807,1.182,1.182,0,0,1,1.661,0,1.086,1.086,0,0,1,.354.807A1.07,1.07,0,0,1,11.426,17.9Zm.283-6.941c-.059.278-.136.6-.226.977-.086.352-.187.792-.3,1.32s-.229,1.178-.354,1.953h-.475q-.185-1.175-.355-1.958t-.3-1.311c-.079-.323-.15-.639-.216-.951a3.652,3.652,0,0,1-.1-.7,1.076,1.076,0,0,1,.351-.808,1.237,1.237,0,0,1,1.693,0,1.067,1.067,0,0,1,.362.808A3.393,3.393,0,0,1,11.709,10.963Z"
                  transform="translate(-1.898 -4.978)"
                />
              </svg>
              <span
                v-if="errors.linkedinLink !== ''"
                class="right-0 absolute mr-5 text-red text-xxs capitalize text-right block w-full"
                >{{ errors.linkedinLink }}
              </span>
            </div>
          </div>
          <div class="flex items-left h-10 w-full items-center">
            <div class="flex items-center w-2/12">
              <input
                id="has-custom"
                v-model="hasCustom"
                type="checkbox"
                class="checkbox mr-2"
                :value="true"
              />
              <label
                class="inline-flex items-center cursor-pointer"
                for="has-custom"
              >
                Custom</label
              >
            </div>
            <div v-show="hasCustom" class="w-10/12">
              <button
                v-show="hasCustom"
                class="text-blue"
                @click="addSocialLink"
                >+ Add Another</button
              >
            </div>
          </div>
          <div
            v-for="(social, index) in customSocials"
            v-show="hasCustom && customSocials.length > 0"
            :key="index"
            class="flex items-left h-10 w-full"
          >
            <div class="flex w-2/12 items-center">
              <button @click="removeSocialLink(index)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="gray"
                >
                  <path
                    d="m336-280-56-56 144-144-144-143 56-56 144 144 143-144 56 56-144 143 144 144-56 56-143-144-144 144Z"
                  />
                </svg>
              </button>
              <div class="ml-1 mr-12">
                <span>Link {{ index + 1 }}</span>
              </div>
            </div>
            <div class="flex w-10/12">
              <div class="w-40 mr-6 relative">
                <input
                  v-model="social['title']"
                  type="text"
                  name="custom-social-title"
                  placeholder="Social Title"
                  class="input"
                  :class="[
                    customSocialErrors[index].title !== '' ? 'border-red' : '',
                  ]"
                  @input="clearCustomSocialErrors(index, true)"
                />
                <svg
                  v-if="customSocialErrors[index].title !== ''"
                  class="absolute right-0 top-0 mr-3 mt-2.5"
                  xmlns="http://www.w3.org/2000/svg"
                  width="17.433"
                  height="15.57"
                  viewBox="0 0 17.433 15.57"
                >
                  <path
                    class="a"
                    fill="red"
                    d="M19.066,17.847,12.211,5.978h0a1.808,1.808,0,0,0-.342-.483,1.772,1.772,0,0,0-2.505,0,1.715,1.715,0,0,0-.307.414h0L2.2,17.781v0a1.727,1.727,0,0,0-.246.535,1.769,1.769,0,0,0,1.764,2.229l13.707,0h0a1.77,1.77,0,0,0,1.636-2.7Zm-7.64.057a1.2,1.2,0,0,1-1.661,0,1.072,1.072,0,0,1-.354-.8,1.087,1.087,0,0,1,.354-.807,1.182,1.182,0,0,1,1.661,0,1.086,1.086,0,0,1,.354.807A1.07,1.07,0,0,1,11.426,17.9Zm.283-6.941c-.059.278-.136.6-.226.977-.086.352-.187.792-.3,1.32s-.229,1.178-.354,1.953h-.475q-.185-1.175-.355-1.958t-.3-1.311c-.079-.323-.15-.639-.216-.951a3.652,3.652,0,0,1-.1-.7,1.076,1.076,0,0,1,.351-.808,1.237,1.237,0,0,1,1.693,0,1.067,1.067,0,0,1,.362.808A3.393,3.393,0,0,1,11.709,10.963Z"
                    transform="translate(-1.898 -4.978)"
                  />
                </svg>
                <span
                  v-if="customSocialErrors[index].title !== ''"
                  class="right-0 absolute mr-1 text-red text-xxs capitalize text-right block w-full"
                  >{{ customSocialErrors[index].title }}
                </span>
              </div>
              <div class="relative flex-grow">
                <input
                  v-model="social['link']"
                  type="text"
                  name="custom-social-link"
                  placeholder="Custom Link"
                  class="input"
                  :class="[
                    customSocialErrors[index].link !== '' ? 'border-red' : '',
                  ]"
                  @input="clearCustomSocialErrors(index, false)"
                />
                <svg
                  v-if="customSocialErrors[index].link !== ''"
                  class="absolute right-0 top-0 mr-3 mt-2.5"
                  xmlns="http://www.w3.org/2000/svg"
                  width="17.433"
                  height="15.57"
                  viewBox="0 0 17.433 15.57"
                >
                  <path
                    class="a"
                    fill="red"
                    d="M19.066,17.847,12.211,5.978h0a1.808,1.808,0,0,0-.342-.483,1.772,1.772,0,0,0-2.505,0,1.715,1.715,0,0,0-.307.414h0L2.2,17.781v0a1.727,1.727,0,0,0-.246.535,1.769,1.769,0,0,0,1.764,2.229l13.707,0h0a1.77,1.77,0,0,0,1.636-2.7Zm-7.64.057a1.2,1.2,0,0,1-1.661,0,1.072,1.072,0,0,1-.354-.8,1.087,1.087,0,0,1,.354-.807,1.182,1.182,0,0,1,1.661,0,1.086,1.086,0,0,1,.354.807A1.07,1.07,0,0,1,11.426,17.9Zm.283-6.941c-.059.278-.136.6-.226.977-.086.352-.187.792-.3,1.32s-.229,1.178-.354,1.953h-.475q-.185-1.175-.355-1.958t-.3-1.311c-.079-.323-.15-.639-.216-.951a3.652,3.652,0,0,1-.1-.7,1.076,1.076,0,0,1,.351-.808,1.237,1.237,0,0,1,1.693,0,1.067,1.067,0,0,1,.362.808A3.393,3.393,0,0,1,11.709,10.963Z"
                    transform="translate(-1.898 -4.978)"
                  />
                </svg>
                <span
                  v-if="customSocialErrors[index].link !== ''"
                  class="right-0 absolute mr-1 text-red text-xxs capitalize text-right block w-full"
                  >{{ customSocialErrors[index].link }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
    <div class="text-left">
      <fieldset class="mt-8 flex -mx-2">
        <legend class="mb-3 text-gray">Public Contact:</legend>
        <div class="w-1/2 flex-grow pr-4 relative">
          <input
            v-model="email"
            type="text"
            name="email"
            placeholder="Email"
            class="input"
            :class="[errors.email !== '' ? 'border-red' : '']"
            @input="clearSubmitErrors('email')"
          />
          <svg
            v-if="errors.email !== ''"
            class="absolute right-0 top-0 mr-7 mt-2.5"
            xmlns="http://www.w3.org/2000/svg"
            width="17.433"
            height="15.57"
            viewBox="0 0 17.433 15.57"
          >
            <path
              class="a"
              fill="red"
              d="M19.066,17.847,12.211,5.978h0a1.808,1.808,0,0,0-.342-.483,1.772,1.772,0,0,0-2.505,0,1.715,1.715,0,0,0-.307.414h0L2.2,17.781v0a1.727,1.727,0,0,0-.246.535,1.769,1.769,0,0,0,1.764,2.229l13.707,0h0a1.77,1.77,0,0,0,1.636-2.7Zm-7.64.057a1.2,1.2,0,0,1-1.661,0,1.072,1.072,0,0,1-.354-.8,1.087,1.087,0,0,1,.354-.807,1.182,1.182,0,0,1,1.661,0,1.086,1.086,0,0,1,.354.807A1.07,1.07,0,0,1,11.426,17.9Zm.283-6.941c-.059.278-.136.6-.226.977-.086.352-.187.792-.3,1.32s-.229,1.178-.354,1.953h-.475q-.185-1.175-.355-1.958t-.3-1.311c-.079-.323-.15-.639-.216-.951a3.652,3.652,0,0,1-.1-.7,1.076,1.076,0,0,1,.351-.808,1.237,1.237,0,0,1,1.693,0,1.067,1.067,0,0,1,.362.808A3.393,3.393,0,0,1,11.709,10.963Z"
              transform="translate(-1.898 -4.978)"
            />
          </svg>
          <span
            v-if="errors.email !== ''"
            class="right-0 absolute mr-5 text-red text-xxs capitalize text-right block w-full"
            >{{ errors.email }}
          </span>
        </div>
        <div class="w-1/2 flex-grow pl-4 pr-4 relative">
          <input
            v-model="phone"
            type="text"
            name="phone"
            placeholder="Phone (—) — —"
            class="input"
            :class="[errors.phone !== '' ? 'border-red' : '']"
            @input="clearSubmitErrors('phone')"
          />
          <svg
            v-if="errors.phone !== ''"
            class="absolute right-0 top-0 mr-7 mt-2.5"
            xmlns="http://www.w3.org/2000/svg"
            width="17.433"
            height="15.57"
            viewBox="0 0 17.433 15.57"
          >
            <path
              class="a"
              fill="red"
              d="M19.066,17.847,12.211,5.978h0a1.808,1.808,0,0,0-.342-.483,1.772,1.772,0,0,0-2.505,0,1.715,1.715,0,0,0-.307.414h0L2.2,17.781v0a1.727,1.727,0,0,0-.246.535,1.769,1.769,0,0,0,1.764,2.229l13.707,0h0a1.77,1.77,0,0,0,1.636-2.7Zm-7.64.057a1.2,1.2,0,0,1-1.661,0,1.072,1.072,0,0,1-.354-.8,1.087,1.087,0,0,1,.354-.807,1.182,1.182,0,0,1,1.661,0,1.086,1.086,0,0,1,.354.807A1.07,1.07,0,0,1,11.426,17.9Zm.283-6.941c-.059.278-.136.6-.226.977-.086.352-.187.792-.3,1.32s-.229,1.178-.354,1.953h-.475q-.185-1.175-.355-1.958t-.3-1.311c-.079-.323-.15-.639-.216-.951a3.652,3.652,0,0,1-.1-.7,1.076,1.076,0,0,1,.351-.808,1.237,1.237,0,0,1,1.693,0,1.067,1.067,0,0,1,.362.808A3.393,3.393,0,0,1,11.709,10.963Z"
              transform="translate(-1.898 -4.978)"
            />
          </svg>
          <span
            v-if="errors.phone !== ''"
            class="right-0 absolute mr-5 text-red text-xxs capitalize text-right block w-full"
            >{{ errors.phone }}
          </span>
        </div>
      </fieldset>
    </div>
    <div class="-mx-2 mt-8 text-left">
      <div class="flex flex-col items-start">
        <label class="text-gray mb-2" for="cause-area">Upload Logo: </label>
        <div class="w-2/3 pr-4 relative">
          <div
            class="input flex items-center justify-between"
            :class="[errors.uploadFile !== '' ? 'border-red' : '']"
            @click="onUploadClick"
          >
            <div class="h-8 rounded-full flex items-center">
              <div class="w-full text-gray pl-1 text-gray cursor-default">
                {{ uploadFileName ? uploadFileName : 'Choose File' }}
              </div>
              <input
                ref="file"
                type="file"
                name="uploadUser"
                class="input opacity-0"
                @change="uploadUserFile"
                @input="clearSubmitErrors('uploadFile')"
              />
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="18"
              height="18"
              viewBox="0 0 471.2 471.2"
              class="r-2"
              style="enable-background: new 0 0 471.2 471.2"
            >
              <g>
                <g>
                  <path
                    d="M457.7,230.15c-7.5,0-13.5,6-13.5,13.5v122.8c0,33.4-27.2,60.5-60.5,60.5H87.5c-33.4,0-60.5-27.2-60.5-60.5v-124.8
                      c0-7.5-6-13.5-13.5-13.5s-13.5,6-13.5,13.5v124.8c0,48.3,39.3,87.5,87.5,87.5h296.2c48.3,0,87.5-39.3,87.5-87.5v-122.8
                      C471.2,236.25,465.2,230.15,457.7,230.15z"
                    fill="#069BD7"
                  />
                  <path
                    d="M159.3,126.15l62.8-62.8v273.9c0,7.5,6,13.5,13.5,13.5s13.5-6,13.5-13.5V63.35l62.8,62.8c2.6,2.6,6.1,4,9.5,4
                      c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.8-85.8c-2.5-2.5-6-4-9.5-4c-3.6,0-7,1.4-9.5,4l-85.8,85.8
                      c-5.3,5.3-5.3,13.8,0,19.1C145.5,131.35,154.1,131.35,159.3,126.15z"
                    fill="#069BD7"
                  />
                </g>
              </g>
            </svg>
          </div>
          <span
            v-if="errors.uploadFile !== ''"
            class="right-0 absolute mr-5 text-red text-xxs capitalize text-right block w-full"
            >{{ errors.uploadFile }}
          </span>
        </div>
      </div>
    </div>
    <div class="text-left">
      <fieldset class="mt-8 flex flex-col items-start -mx-2">
        <legend class="text-gray">Marketing Release?</legend>
        <span
          >Do we have permission to post about our partnership on social media
          and our website?</span
        >
        <div class="flex mt-3">
          <div class="flex items-center mr-4">
            <input
              id="yes-marketing-release"
              v-model="marketingRelease"
              type="radio"
              class="checkbox mr-2"
              name="marketing-release"
              :value="1"
            />
            <label
              class="inline-flex items-center cursor-pointer"
              for="yes-marketing-release"
            >
              Yes</label
            >
          </div>
          <div class="flex items-center mr-5">
            <input
              id="no-marketing-release"
              v-model="marketingRelease"
              type="radio"
              class="checkbox mr-2"
              name="marketing-release"
              :value="0"
            />
            <label
              class="inline-flex items-center cursor-pointer"
              for="no-marketing-release"
            >
              No</label
            >
          </div>
        </div>
      </fieldset>
    </div>
    <div class="pl-2 pr-4 mt-8 mb-4">
      <button
        class="primary-button"
        :disabled="isTryingToSignupOrganization"
        @click="submitSocialsForm"
      >
        <span v-if="isTryingToSignupOrganization">Loading</span>
        <span v-if="!isTryingToSignupOrganization">Next</span>
      </button>
    </div>
  </div>
</template>
